export default __webpack_public_path__ + "static/hero-fire-bg-desktop-661ad7d5123503fc315c0ecc106a6831.jpg";